import { render } from "./AddExpense.vue?vue&type=template&id=2cfb576c&scoped=true"
import script from "./AddExpense.vue?vue&type=script&lang=js"
export * from "./AddExpense.vue?vue&type=script&lang=js"

import "./AddExpense.vue?vue&type=style&index=0&id=2cfb576c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfb576c"]])

export default __exports__